















































import Vue from 'vue';
import Customer from '../../../models/Customer';
import { Sex } from '../../../models/Customer';
import customerClient from '../../../apis';

export default Vue.extend({
  props: {
    customer: Customer,
  },
  data() {
    return {
      showRemarkNameEdit: false,
      localRemarkName: null,
      lastRemarkName: null,
      avatarUrl: require('assets/img/common/avatar.png'),
    };
  },
  computed: {
    sexClass(): string {
      if (this.customer.wxProps.sex === Sex.Male) {
        return 'icon-male';
      } else if (this.customer.wxProps.sex === Sex.Female) {
        return 'icon-female';
      } else {
        return '';
      }
    },
    location(): string {
      if (this.customer.wxProps.country !== '中国') {
        return this.customer.wxProps.country;
      } else {
        return [
          this.customer.wxProps.province,
          this.customer.wxProps.city,
        ].filter((s) => {
          return s && s.trim() !== '';
        }).join(',');
      }
    },
    avatar(): string {  
      return this.customer.wxProps.headimgurl ? this.customer.wxProps.headimgurl.replace('http://', 'https://') : this.avatarUrl;
    },
  },
  methods: {
    updateRemarkName() {
      if (this.localRemarkName === this.customer.remarkName) {
        this.$Message.success('修改备注名成功');
        this.showRemarkNameEdit = false;
      } else {
        customerClient.updateRemarkName({openid: this.customer.openid, remarkName: this.localRemarkName}).success(() => {
          this.$Message.success('修改备注名成功');
          this.lastRemarkName = this.localRemarkName;
          this.showRemarkNameEdit = false;
        }).error(() => {
          this.$Message.error('修改错误，请刷新重试');
        });
      }
    },
  },
  mounted() {
    this.localRemarkName = this.customer.remarkName;
    this.lastRemarkName = this.customer.remarkName;
  },
});
